export const CATEGORIES = [
  { id: "all", name: "全部瓜田", desc: "一站式看完所有分类" },
  { id: "film", name: "影视圈", icon: "ri-movie-2-line", desc: "热剧排播、幕后花絮与番位话题" },
  { id: "variety", name: "综艺现场", icon: "ri-live-line", desc: "音综、竞演与真人秀的台前幕后" },
  { id: "music", name: "音乐现场", icon: "ri-music-2-line", desc: "新歌打榜、巡演与乐坛风向" },
  { id: "redcarpet", name: "红毯秀场", icon: "ri-camera-3-line", desc: "电影节红毯与品牌盛典盘点" },
  { id: "brand", name: "品牌行业", icon: "ri-price-tag-3-line", desc: "营销打法与行业生意经拆解" },
  { id: "tech", name: "科技互联网", icon: "ri-command-line", desc: "新机发布、产品与平台动向" },
];

export const CATEGORY_META: Record<string, { name: string; dot: string }> = {
  film: { name: "影视圈", dot: "bg-primary-500" },
  variety: { name: "综艺现场", dot: "bg-accent-500" },
  music: { name: "音乐现场", dot: "bg-secondary-500" },
  redcarpet: { name: "红毯秀场", dot: "bg-primary-600" },
  brand: { name: "品牌行业", dot: "bg-accent-600" },
  tech: { name: "科技互联网", dot: "bg-secondary-600" },
};

export const STATS = [
  { value: "4,800+", label: "已整理吃瓜事件" },
  { value: "320+", label: "完结时间线合集" },
  { value: "24h", label: "全天候线索追踪" },
  { value: "120w+", label: "每月追更瓜友" },
];

export const HOT_EVENTS = [
  {
    id: "h1",
    category: "film",
    rank: 1,
    heat: "98.6万",
    tag: "进行中",
    time: "26分钟前",
    title: "暑期档排片与口碑之争白热化，多平台延长点映被逐帧解读",
    excerpt: "从点映场次到排片占比，再到口碑风向的每一次变化都被整理成时间节点。编辑组已按日期回溯全部公开信息，瓜友可直接顺时间线看完整进程。",
  },
  {
    id: "h2",
    category: "variety",
    rank: 2,
    heat: "86.2万",
    tag: "热度飙升",
    time: "1小时前",
    title: "爆款音综收官夜收视新高，衍生节目与巡演同步提上日程",
    excerpt: "收官夜的舞台切片、金句与收视曲线集中刷屏。围绕下一季阵容与舞台班底，官方尚未回应，讨论仍在发酵中。",
  },
  {
    id: "h3",
    category: "redcarpet",
    rank: 3,
    heat: "74.5万",
    tag: "正在整理",
    time: "3小时前",
    title: "电影节红毯造型集中盘点，高定与国风同台竞技成焦点",
    excerpt: "数十套造型按出场顺序排好，编辑组补充了妆造团队与穿搭细节。想看全片或只想看重点，两条路径都已备好。",
  },
  {
    id: "h4",
    category: "music",
    rank: 4,
    heat: "61.8万",
    tag: "已完结",
    time: "5小时前",
    title: "新歌上线三小时冲上实时榜前列，编曲与词作风格大变引讨论",
    excerpt: "从预告短片到全曲上线的完整时间线已更新完毕。词曲署名、制作班底与过往作品对比是本期重点梳理内容。",
  },
  {
    id: "h5",
    category: "brand",
    rank: 5,
    heat: "52.3万",
    tag: "热度飙升",
    time: "8小时前",
    title: "国产美妆联名上线即售罄，预售节奏与营销打法被逐条拆解",
    excerpt: "从预热物料到补货公告，营销链条里的每一步都被整理出来。品牌方并未回应争议，生意经与舆情两条线都在追。",
  },
  {
    id: "h6",
    category: "tech",
    rank: 6,
    heat: "47.9万",
    tag: "已完结",
    time: "12小时前",
    title: "两场大厂发布会正面撞车，参数对比楼一夜盖过千层",
    excerpt: "发布会同场开始，编辑组同步抓取关键参数生成速览。各平台评测观点按时间线收录，想对比可以一次看完。",
  },
  {
    id: "h7",
    category: "film",
    rank: 7,
    heat: "39.4万",
    tag: "持续更新",
    time: "16小时前",
    title: "老戏骨新剧开机路透刷屏，主创班底与选角传闻齐飞",
    excerpt: "开机现场照流出后，围绕班底构成与档期安排的讨论不断。相关公开物料与过往作品链接均已整理进事件页。",
  },
  {
    id: "h8",
    category: "variety",
    rank: 8,
    heat: "31.7万",
    tag: "进行中",
    time: "1天前",
    title: "新一季真人秀名单提前流出，瓜友竞猜玩法持续升温",
    excerpt: "疑似嘉宾名单引发多方猜测。编辑组整理了历年同类型节目规律，供瓜友对照参考，官方口径尚未更新。",
  },
  {
    id: "h9",
    category: "music",
    rank: 9,
    heat: "26.1万",
    tag: "正在整理",
    time: "1天前",
    title: "巡演加场城市官宣，抢票难度与渠道规则成为新话题",
    excerpt: "加场与放票时间同步放出，抢票难度再次成为讨论焦点。各站购票规则与网友经验帖已按城市归好类。",
  },
];

export const COLLECTIONS = [
  {
    id: "c1",
    category: "film",
    name: "暑期档票房拉锯战全记录",
    stage: 12,
    span: "3个月",
    members: "8.6万人在追",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20film%20theater%20ambience%20with%20red%20seats%20and%20projector%20light%20beam%2C%20dark%20moody%20terracotta%20and%20amber%20tone%2C%20premium%20editorial%20photography%2C%20no%20text%2C%20no%20people%20faces&width=800&height=600&seq=collect-film&orientation=squarish",
    summary:
      "从定档到收官，把排片、口碑与票房曲线的每一步都按时间排好，新瓜友可从零开始一口气读完这段完整博弈。",
  },
  {
    id: "c2",
    category: "variety",
    name: "一档音综从立项到收官",
    stage: 9,
    span: "2个月",
    members: "5.3万人在追",
    cover:
      "https://readdy.ai/api/search-image?query=Stage%20spotlight%20on%20a%20warm%20concert%20stage%20with%20soft%20amber%20haze%2C%20guitar%20silhouette%2C%20cinematic%20editorial%20mood%2C%20deep%20terracotta%20tones%2C%20no%20text%2C%20no%20clear%20faces&width=800&height=600&seq=collect-variety&orientation=squarish",
    summary:
      "导师、选手与舞台名场面按期数串成一条线，衍生讨论与数据表现同步标注，适合想完整补课的综艺老粉。",
  },
  {
    id: "c3",
    category: "brand",
    name: "高端餐饮排队内幕调查",
    stage: 7,
    span: "1个月",
    members: "3.9万人在追",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20food%20scene%20with%20artisan%20restaurant%20interior%2C%20soft%20golden%20light%2C%20plate%20detail%2C%20premium%20magazine%20style%2C%20muted%20terracotta%20palette%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=collect-brand&orientation=squarish",
    summary:
      "从排队截图到商家回应，把话题餐厅的饥饿营销套路逐环拆开，梳理出其中被反复使用的生意经与传播路径。",
  },
  {
    id: "c4",
    category: "tech",
    name: "AI短剧赛道开卷时刻",
    stage: 10,
    span: "2个月",
    members: "6.1万人在追",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20futuristic%20AI%20studio%20scene%20in%20warm%20amber%20and%20terracotta%20glow%2C%20streaming%20data%20light%20strands%2C%20premium%20tech%20editorial%20background%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=collect-tech&orientation=squarish",
    summary:
      "各平台 AI 短剧产品接连上线，编辑组把时间表、玩法与行业反馈排成时间线，看谁先跑通这条路。",
  },
];

export const FEATURED_TIMELINE = {
  category: "variety",
  badge: "本周头号瓜田",
  title: "一档现象级综艺的“烂尾”与“封神”之争",
  lead: "同一档节目，有人说是年度封神，有人吐槽高开低走。为了看清楚来龙去脉，我们把整季关键节点按时间全部排开——不看粉丝滤镜，只看顺序发生的事实。",
  stages: [
    { time: "季初 · 第1-2期", title: "阵容官宣与首播炸场", text: "导师名单与赛制率先点燃讨论，首播舞台切片集中刷屏，热度创下档期新高。" },
    { time: "中段 · 第4-6期", title: "赛制争议逐渐冒头", text: "关于剪辑、镜头分配与淘汰规则的讨论开始增多，官方评论区出现两种完全相反的声音。" },
    { time: "中段 · 第7-8期", title: "一轮舆论反转上演", text: "某轮结果公布后，讨论从赛制蔓延到选手与导师，多个话题先后冲上热榜，观点快速对立。" },
    { time: "尾声 · 第9-10期", title: "收官夜与衍生动作", text: "收官收视创下新高，随后官方火速公布衍生节目与巡演计划，被部分瓜友解读为趁热加更。" },
    { time: "完结后 2 周", title: "热度回落到口碑复盘", text: "尘埃落定后，编辑组梳理整季数据曲线与各期口碑，发现高光与争议往往出自同几个节点。" },
  ],
  conclusion:
    "整理完可以发现，所谓“封神”与“烂尾”并不是一个结论，而是同一条时间线上先后出现的两个切片。把它排开看，很多当初吵得不可开交的点，其实都有先后因果。",
};

export const DEEP_DIVES = [
  {
    id: "d1",
    category: "brand",
    tag: "行业盘点",
    title: "“联名即售罄”为什么总是一遍遍奏效？拆解饥饿营销的完整链条",
    summary:
      "从预告倒计时、限量补货到二手溢价，联名爆款的每一步几乎都是可复制的打法。我们把最近几个案例放在一起，逐环拆开看它的传播逻辑。",
    body: [
      "先看预热。几乎每一场刷屏的联名，都有一个统一的节奏：提前多日放出悬念物料，锁定时间制造“错过不再”的紧迫感，再用 KOL 开箱把期待推到最高点。",
      "再看开售。限量、补货、秒空三件套同时出现，配合话题标签反复放大“抢不到”本身，让稀缺成为二次传播的内容，而不仅仅是结果。",
      "最后看溢价与二手。当官方渠道售罄，转售平台的价格曲线会反过来给新品做免费背书。商家的下一步动作，往往就是“预计下月回归”，把流量再收割一轮。",
      "这套打法本身不新鲜，真正值得注意的是它的适配边界——并不是所有品类都适合，强话题、强视觉、可收藏的商品更容易吃到红利。",
    ],
  },
  {
    id: "d2",
    category: "variety",
    tag: "内容复盘",
    title: "为何真人秀的“反转”越来越像剧本？观众到底在追什么",
    summary:
      "当争议开始有固定模板，观众的爽点与痛点也在同步升级。这篇文章聊聊真人秀话题生产背后的结构，以及我们更愿意相信怎样的叙事。",
    body: [
      "翻看近两年的话题性真人秀，你会发现高潮段落高度相似：先是预告制造悬念，接着正片放出反转，最后评论区自动分成两派。结构趋同，不代表内容是假的，只是说明平台已经非常懂如何设计观看曲线。",
      "对观众而言，追综艺早已不只是看结果。人们在意的往往是“过程里谁被公平对待”，这也解释了为什么剪辑、镜头量与淘汰规则会一次次成为主战场。",
      "编辑组的判断是：与其急着站队，不如先看清每个节点的先后顺序。谁先发声、谁后回应、中间隔了多久，这些时间信息往往比情绪更能说明问题。",
    ],
  },
  {
    id: "d3",
    category: "tech",
    tag: "行业观察",
    title: "AI 生成内容涌入流媒体，短剧赛道会先跑出胜负手吗",
    summary:
      "当一部剧的成本与制作周期被大幅压缩，内容供给的结构正在悄悄改变。我们把近期新动态整理成一份可读的行业时间线。",
    body: [
      "从产品侧看，多家平台已把 AI 短剧做成独立入口，更新频率与题材供给远超真人剧。成本结构的变化，让“日更”第一次在影视内容里变得现实。",
      "从观众侧看，接受度分化明显：年轻用户更愿意尝鲜，传统剧迷则对质感与演技上限存疑。两种声音在各大平台的讨论区正面碰撞。",
      "编辑组认为，这条赛道真正的看点不在单部作品，而在于谁先解决“稳定产出 + 持续热度”这对矛盾。我们会持续把新节点排进时间线，方便你回看演进过程。",
    ],
  },
  {
    id: "d4",
    category: "film",
    tag: "观影指南",
    title: "补课指南：跟不上“高开低走”的讨论，如何快速理顺一部热剧的完整叙事",
    summary:
      "热门剧的讨论往往等不到结局就先吵起来。我们提供一个通用补课路径：按时间线、按人物、按口碑三段式切入，快速跟上进度。",
    body: [
      "第一步按时间线：从定档、开播到每次口碑变化，先把事件的先后顺序建立起来，避免被零散的切片打乱判断。",
      "第二步按人物：理清角色之间的关系与争议来源，很多争吵其实来自对同一情节的不同解读，而不是事实分歧。",
      "第三步看口碑曲线：把各平台的评分与讨论量随时间画出来，往往能清晰看出“高开低走”究竟断在哪一期、又因为什么。",
      "这套方法同样适用于吃瓜：先排时间、再看立场、最后下判断，能帮你少走很多弯路。",
    ],
  },
];

export const FAQS = [
  {
    q: "“今日吃瓜事件合集”里的内容是按什么顺序排列的？",
    a: "所有合集与事件时间线都严格按照时间先后排序，从起因、发酵、反转到收尾一路排开，让你能像追连续剧一样看完完整事件，不用再东翻一帖西看一段。",
  },
  {
    q: "“吃瓜事件盘点”和“事件合集”有什么区别？",
    a: "盘点偏重观点与脉络的总结，适合想快速抓住重点的朋友；合集则是一份按时间排好的原始素材时间线，适合想亲自看完完整经过的深度瓜友。两套路径我们都做了整理。",
  },
  {
    q: "为什么同一事件会出现“进行中”“已完结”的标签？",
    a: "标签反映的是事件当前的更新状态：“进行中”表示官方或各方尚未回应、仍在发酵；“已完结”表示我们已经整理出完整闭环；而“持续更新”意味着有新节点会陆续补进时间线。",
  },
  {
    q: "我想追一个明星或行业的瓜，在哪里订阅更新？",
    a: "你可以在首页“追更订阅”区填写邮箱并选择关注的分类。每次该分类有新的盘点或合集时间线更新，我们会第一时间把链接推送到你的邮箱，方便你第一时间跟上进度。",
  },
  {
    q: "看到整理有遗漏或错误，可以帮忙纠正吗？",
    a: "非常欢迎。每张事件卡片与时间线里都预留了反馈入口，你可以把遗漏的公开线索或时间节点发给我们，编辑组核对后会尽快补进对应合集，并保持时间线完整。",
  },
  {
    q: "内容来源可靠吗？如何保证不传谣？",
    a: "我们只整理已公开、可回溯的信息，并为每个关键节点标注时间与出处，不采信单一匿名爆料。涉及事实的内容我们会等待官方回应后再更新，宁可慢一点，也不拼凑未经证实的说法。",
  },
  {
    q: "使用今日瓜报需要付费吗？",
    a: "基础的事件盘点、合集时间线与分类浏览全部免费开放。我们不会设置付费才能看正文的机制，订阅也只用于把更新推送到你的邮箱，不会用于其他用途。",
  },
];

export const TESTIMONIALS = [
  {
    name: "追更的栗子",
    role: "影视区常驻瓜友",
    avatar: "栗",
    text: "之前吃瓜全靠自己东翻西帖，经常看完一半不知道前面发生了什么。有了按时间排的合集，新剧的完整脉络一晚就能捋清楚，省心太多了。",
  },
  {
    name: "夜猫子看客",
    role: "综艺档忠实观众",
    avatar: "夜",
    text: "最喜欢“进行中 / 已完结”这种状态标注，一眼就知道这事还能不能继续蹲。整理组补出处这一点很加分，起码知道哪句是官方说的。",
  },
  {
    name: "瓜田拾荒者",
    role: "行业瓜爱好者",
    avatar: "拾",
    text: "本来以为只是明星八卦，没想到还有品牌和科技互联网的分类。营销打法的逐环拆解写得挺扎实，当成行业观察读也成立。",
  },
];

export const NAV_LINKS = [
  { id: "hot", label: "今日热点", anchor: "#hot" },
  { id: "collections", label: "整瓜合集", anchor: "#collections" },
  { id: "focus", label: "深度盘点", anchor: "#focus" },
  { id: "about", label: "关于我们", anchor: "#about" },
  { id: "faq", label: "常见问题", anchor: "#faq" },
];